import React from "react";
import AppHeader from "../common/AppHeader";
import { FaCalendarAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import BottomNav from "../common/BottomNav";
import { useTranslation } from "react-i18next";
import styles from "../css/Manage.module.css";

const manageItems = [
  {
    key: "manage_listings",
    label: "Manage Listings",
    icon: <FaCalendarAlt size={40} color="#ec4899" />,
    path: "/manage-event-services",
    gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
    bgColor: "#fef3f8",
    upcoming: false,
    desc: "Manage all your service listings",
  }
];

export default function Manage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <AppHeader
        title={t("Manage.manage_services", "Manage Services")}
        showBack={true}
      />

      {/* Hero Section */}
      <div className={styles.hero}>
        <div className={styles.heroCard}>
          <div className={styles.heroCircle1} />
          <div className={styles.heroCircle2} />
          <div style={{ position: "relative", zIndex: 1 }}>
            <h2 className={styles.heroTitle}>
              {t("Manage.manage_your_services", "Manage Your Services")}
            </h2>
            <p className={styles.heroDesc}>
              {t(
                "Manage.edit_update_delete",
                "Edit, update, or delete your services and resources from one place."
              )}
            </p>
          </div>
        </div>
      </div>

      {/* Service Grid */}
      <div className={styles.gridWrapper}>
        <h3 className={styles.gridTitle}>
          {t("Manage.your_services", "Your Services")}
        </h3>
        <div className={styles.grid} style={{ gridTemplateColumns: '1fr', gap: '20px', maxWidth: '500px', margin: '0 auto' }}>
          {manageItems.map((item, index) => (
            <div
              key={item.key}
              className={`${styles.gridItem} ${item.upcoming ? styles.upcoming : ""}`}
              onClick={() => {
                if (!item.upcoming) {
                  navigate(item.path);
                }
              }}
              style={{
                animationDelay: `${index * 0.1}s`,
                background: "#fff",
                border: "1px solid rgba(0, 0, 0, 0.04)",
                padding: '32px 24px',
                minHeight: '180px'
              }}
            >
              <div className={styles.icon} style={{ 
                background: item.bgColor,
                width: '80px',
                height: '80px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {item.icon}
              </div>
              <span className={styles.label} style={{ fontSize: '20px', fontWeight: '600' }}>
                {t(`Manage.${item.key}`, item.label)}
              </span>
              <span className={styles.desc} style={{ fontSize: '15px' }}>
                {t(`Manage.${item.key}_desc`, item.desc)}
              </span>
              {item.upcoming && (
                <span className={styles.soon}>
                  {t("Manage.coming_soon", "SOON")}
                </span>
              )}
            </div>
          ))}
        </div>
        {/* Info Card */}
        <div className={styles.infoCard}>
          <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
            <div className={styles.infoIcon}>
              <span style={{ fontSize: 18 }}>⚙️</span>
            </div>
            <div>
              <h4 className={styles.infoTitle}>
                {t("Manage.quick_access", "Quick Access")}
              </h4>
              <p className={styles.infoDesc}>
                {t(
                  "Manage.quick_access_desc",
                  "Keep your services up-to-date with accurate information to maximize bookings and customer satisfaction."
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
      <BottomNav />
    </div>
  );
}